<template>
  <div class="global-container">
    <div class="content">
      <!-- Header with Back Button -->
      <div class="header">
        <button class="back-button" @click="handleBack">
          <span class="arrow">←</span>
        </button>
        <div class="header-text">
          <h1 class="page-title">New Accounting Year</h1>
          <p class="page-description">Create a new accounting period</p>
        </div>
      </div>

      <!-- Form Card -->
      <div class="form-card">
        <div class="form-header">
          <span class="form-icon">📅</span>
          <h2 class="form-title">Accounting Year Details</h2>
        </div>

        <form @submit.prevent="handleSubmit" class="form">
          <!-- Name Field -->
          <div class="form-group">
            <label class="form-label">Name</label>
            <input
              v-model="form.name"
              type="text"
              placeholder="FY 2026-27"
              class="form-input"
            />
          </div>

          <!-- Date Fields -->
          <div class="date-row">
            <div class="form-group">
              <label class="form-label">Start Date</label>
              <div class="date-input-wrapper">
                <input
                  v-model="form.startDate"
                  type="date"
                  placeholder="mm/dd/yyyy"
                  class="form-input date-input"
                />
                <span class="date-icon">📅</span>
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">End Date</label>
              <div class="date-input-wrapper">
                <input
                  v-model="form.endDate"
                  type="date"
                  placeholder="mm/dd/yyyy"
                  class="form-input date-input"
                />
                <span class="date-icon">📅</span>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="button-group">
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-if="loading">Creating Accounting Year...</span>
              <span v-else>Create Accounting Year</span>
            </button>
            <button type="button" class="btn btn-secondary" @click="handleCancel">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'AddAccountingYear',
  data() {
    return {
      form: {
        name: '',
        startDate: '',
        endDate: ''
      }
    }
  },
    methods: {
    ...mapActions('accounting', ['AddAccountingYear']),
    handleBack() {
      this.$router.back()
    },
    handleCancel() {
      this.$router.back()
    },
    async handleSubmit() {
        try {
            const payload = {
                name: this.form.name,
                startDate: new Date(this.form.startDate).toISOString(),
                endDate: new Date(this.form.endDate).toISOString()
            }
            await this.AddAccountingYear(payload)
    } catch (e) {
      console.error(e)
    }
    }
    },
    computed: {
    ...mapState('accounting', ['loading'])
  }
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 32px;
}

.back-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-size: 24px;
  transition: color 0.2s ease;
  margin-top: 4px;
}

.back-button:hover {
  color: #1f2937;
}

.arrow {
  font-size: 28px;
}

.header-text {
  flex: 1;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.page-description {
  font-size: 15px;
  color: #9ca3af;
  margin: 0;
  font-weight: 400;
}

/* Form Card */
.form-card {
  background: white;
  border-radius: 12px;
  padding: 32px;
  max-width: 700px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.form-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}

.form-icon {
  font-size: 24px;
}

.form-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

/* Form Elements */
.form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.form-input {
  padding: 10px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.2s ease;
  background: #f9fafb;
}

.form-input:focus {
  outline: none;
  border-color: #2563eb;
  background: white;
}

.form-input::placeholder {
  color: #d1d5db;
}

/* Date Input Wrapper */
.date-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.date-input {
  width: 100%;
  padding-right: 40px;
}

.date-icon {
  position: absolute;
  right: 12px;
  font-size: 16px;
  pointer-events: none;
}

/* Date Row */
.date-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

/* Button Group */
.button-group {
  display: flex;
  gap: 12px;
  margin-top: 32px;
}

.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}

.btn-primary {
  background: #2563eb;
  color: white;
}

.btn-primary:hover {
  background: #1d4ed8;
}

.btn-secondary {
  background: #f3f4f6;
  color: #1f2937;
  border: 1px solid #e5e7eb;
}

.btn-secondary:hover {
  background: #e5e7eb;
}

/* Responsive */
@media (max-width: 768px) {
  .header {
    flex-direction: column;
    gap: 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .form-card {
    padding: 24px;
  }

  .date-row {
    grid-template-columns: 1fr;
  }

  .button-group {
    flex-direction: column;
  }
}
</style>
